/* ============================================================
   Polish Gallery — theme interactions
   ============================================================ */
(function () {
  'use strict';

  const money = (cents) => {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    const menu = document.querySelector('[data-mobile-menu]');
    const toggles = document.querySelectorAll('[data-menu-toggle]');
    if (!menu) return;
    toggles.forEach((btn) => {
      btn.addEventListener('click', () => {
        const isOpen = !menu.hasAttribute('hidden');
        if (isOpen) {
          menu.setAttribute('hidden', '');
          document.body.style.overflow = '';
        } else {
          menu.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
        }
        const opener = document.querySelector('[data-menu-toggle][aria-expanded]');
        if (opener) opener.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  /* ---------- Search modal ---------- */
  function initSearch() {
    const modal = document.querySelector('[data-search-modal]');
    const openBtn = document.querySelector('[data-search-toggle]');
    const closeBtn = document.querySelector('[data-search-close]');
    if (!modal || !openBtn) return;
    openBtn.addEventListener('click', () => {
      modal.removeAttribute('hidden');
      const input = modal.querySelector('input[type="search"]');
      if (input) input.focus();
    });
    if (closeBtn) closeBtn.addEventListener('click', () => modal.setAttribute('hidden', ''));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') modal.setAttribute('hidden', '');
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    const gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    const main = gallery.querySelector('[data-main-image]');
    const thumbs = gallery.querySelectorAll('[data-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (main) main.src = thumb.dataset.full;
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Quantity steppers (product page) ---------- */
  function initQuantity() {
    const input = document.querySelector('[data-qty-input]');
    if (!input) return;
    const minus = document.querySelector('[data-qty-minus]');
    const plus = document.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', () => {
      const val = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = val;
    });
    if (plus) plus.addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    const form = document.querySelector('[data-product-form]');
    const section = document.querySelector('[data-product-section]');
    if (!form || !section) return;

    const jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    const select = form.querySelector('[data-variant-select]');
    const optionButtons = form.querySelectorAll('[data-option-value]');
    const priceEl = section.querySelector('[data-price]');
    const submit = form.querySelector('[data-add-to-cart]');
    const submitLabel = form.querySelector('[data-add-label]');
    const skuEl = section.querySelector('[data-sku]');
    const mainImage = section.querySelector('[data-main-image]');

    // Track current selection per option position
    const selected = {};
    optionButtons.forEach((btn) => {
      const pos = btn.dataset.optionPosition;
      if (btn.classList.contains('is-selected')) selected[pos] = btn.dataset.value;
    });

    function findVariant() {
      const positions = Object.keys(selected).sort();
      return variants.find((v) => {
        return positions.every((pos) => {
          const idx = parseInt(pos, 10) - 1;
          return v.options[idx] === selected[pos];
        });
      });
    }

    function updateUI() {
      const variant = findVariant();
      if (!variant) {
        if (submit) { submit.setAttribute('disabled', ''); }
        if (submitLabel) submitLabel.textContent = 'Unavailable';
        return;
      }
      if (select) select.value = variant.id;

      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = '<span class="price--sale">' + money(variant.price) + '</span> <s class="price--compare">' + money(variant.compare_at_price) + '</s>';
        } else {
          priceEl.textContent = money(variant.price);
        }
      }
      if (skuEl && variant.sku) skuEl.textContent = variant.sku;
      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.src = variant.featured_image.src;
      }
      if (submit && submitLabel) {
        if (variant.available) {
          submit.removeAttribute('disabled');
          submitLabel.textContent = 'Add to cart';
        } else {
          submit.setAttribute('disabled', '');
          submitLabel.textContent = 'Sold out';
        }
      }
    }

    optionButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const pos = btn.dataset.optionPosition;
        selected[pos] = btn.dataset.value;
        // update selected styling within this option group
        form.querySelectorAll('[data-option-position="' + pos + '"]').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        updateUI();
      });
    });

    updateUI();
  }

  /* ---------- Add to cart (AJAX) ---------- */
  function initAddToCart() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submit = form.querySelector('[data-add-to-cart]');
      const label = form.querySelector('[data-add-label]');
      const original = label ? label.textContent : '';
      if (submit) submit.setAttribute('disabled', '');
      if (label) label.textContent = 'Adding...';
      try {
        const formData = new FormData(form);
        const res = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!res.ok) throw new Error('add failed');
        await res.json();
        await refreshCartCount();
        if (label) label.textContent = 'Added ✓';
        setTimeout(() => {
          if (label) label.textContent = original;
          if (submit) submit.removeAttribute('disabled');
        }, 1400);
      } catch (err) {
        if (label) label.textContent = original;
        if (submit) submit.removeAttribute('disabled');
        window.location.href = window.routes.cart_url;
      }
    });
  }

  async function refreshCartCount() {
    try {
      const res = await fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      const el = document.querySelector('[data-cart-count]');
      if (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      }
    } catch (e) { /* noop */ }
  }

  /* ---------- Cart page updates ---------- */
  function initCartPage() {
    const cartForm = document.querySelector('[data-cart-form]');
    if (!cartForm) return;

    async function changeLine(line, quantity) {
      const res = await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      const cart = await res.json();
      window.location.reload();
      return cart;
    }

    cartForm.querySelectorAll('[data-cart-plus]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const line = btn.dataset.line;
        const input = cartForm.querySelector('[data-cart-qty][data-line="' + line + '"]');
        changeLine(parseInt(line, 10), parseInt(input.value, 10) + 1);
      });
    });
    cartForm.querySelectorAll('[data-cart-minus]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const line = btn.dataset.line;
        const input = cartForm.querySelector('[data-cart-qty][data-line="' + line + '"]');
        changeLine(parseInt(line, 10), Math.max(0, parseInt(input.value, 10) - 1));
      });
    });
    cartForm.querySelectorAll('[data-cart-qty]').forEach((input) => {
      input.addEventListener('change', () => {
        changeLine(parseInt(input.dataset.line, 10), parseInt(input.value, 10));
      });
    });
    cartForm.querySelectorAll('[data-cart-remove]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        changeLine(parseInt(link.dataset.line, 10), 0);
      });
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    const select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Customer recover toggle ---------- */
  function initRecover() {
    const toggle = document.querySelector('[data-recover-toggle]');
    const recover = document.querySelector('#recover');
    if (!toggle || !recover) return;
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      recover.hidden = !recover.hidden;
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
    initSearch();
    initGallery();
    initQuantity();
    initVariants();
    initAddToCart();
    initCartPage();
    initSort();
    initRecover();
    refreshCartCount();
  });
})();
